module.exports = __webpack_public_path__ + "img/lessonpre_add_normal.47ce2578.svg";